export default "__VITE_ASSET__CTRq2559__"